import React from 'react';
import styled from 'styled-components';
import image from '../../images/design_works_suffix.png';

const Background = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  background-color: #f0f0f0;
  padding: 20px;
  box-sizing: border-box;
`;


const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Square = styled.div`
  flex-basis: 200px;
  height: 200px;
  background-color: #46331e;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0px 10px;

  @media (max-width: 768px) {
    flex-basis: 120px;
    height: 120px;
    margin-right: 10px;
  }
`;


const TextSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const MessageTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 12px;
}
`;

const MessageBody = styled.p`
  font-size: 16px;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 10px;
}

`;

const ImageGallery = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  margin: 0px 0px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 12px;
}
`;

const Subtitle = styled.p`
  font-size: 16px;
  margin: 0;
  margin-top: 8px;

  @media (max-width: 768px) {
    font-size: 10px;
}
`;

const DesignWorksCrossHotel = () => {
  return (
    <Background>
      <ContentRow>
        <Square>
          <Title>WORKS</Title>
          <Subtitle>サフィックス様</Subtitle>
        </Square>
        <TextSection>
          <MessageTitle>
          製品パッケージリニューアルにおけるデザイン作成およびパッケージ制作およびマーケティング支援
          </MessageTitle>
          <MessageBody>
          商品パッケージのデザイン/手配、撮影、ブランディング、SNSマーケティングを企画・実施
          </MessageBody>
        </TextSection>
      </ContentRow>
      <ImageGallery>
        <StyledImage
          src={image}
          alt="Design Work"
        />
      </ImageGallery>
    </Background>
  );
};

export default DesignWorksCrossHotel;
